import src from "IMAGE";
export default { src, width: 799, height: 799, blurWidth: 0, blurHeight: 0};
